
import { defineComponent, type PropType } from 'vue'
import { MetricType } from '~/types/metric'

import type { RepositoryMetricValue } from '~/types/types'

enum VALUE_STATE {
  ABOVE = 'Above threshold',
  BELOW = 'Below threshold',
  MEETS = 'Meets threshold'
}

const ICON_VALUE_STATE = {
  [VALUE_STATE.ABOVE]: 'metric-high',
  [VALUE_STATE.BELOW]: 'metric-low',
  [VALUE_STATE.MEETS]: 'metric-medium'
}

export default defineComponent({
  name: 'RunMetricRow',
  props: {
    metric: {
      type: Object as PropType<RepositoryMetricValue>,
      required: true
    },
    showNamespace: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default: ''
    },
    canSuppressMetric: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    trendDisplay(): string {
      return this.metric.valueTrendDisplay?.split(' ')?.[1] ?? ''
    },
    trendDirection(): string {
      return this.metric.valueTrendDisplay?.split(' ')?.[0]?.toLowerCase() ?? ''
    },
    trendPositive(): boolean {
      if (this.metric.value === null || this.metric.value === undefined) {
        return true
      }

      if (this.trendDirection && this.metric.value !== null && this.metric.value !== undefined) {
        return (
          (this.trendDirection === 'down' && !this.metric.trendPositive) ||
          (this.trendDirection === 'up' && this.metric.trendPositive)
        )
      } else {
        return false
      }
    },
    trendIsPercent(): boolean {
      return this.metric.valueTrendDisplay?.includes('%') ?? false
    },
    metricThresholdRelation(): VALUE_STATE | '' {
      if (
        this.metric.value !== null &&
        this.metric.value !== undefined &&
        this.metric.threshold !== null &&
        this.metric.threshold !== undefined
      ) {
        if (this.metric.value === this.metric.threshold) {
          return VALUE_STATE.MEETS
        }
        if (this.metric.value > this.metric.threshold) {
          return VALUE_STATE.ABOVE
        }
        return VALUE_STATE.BELOW
      }
      return ''
    },
    metricThresholdRelationIcon(): string {
      return this.metricThresholdRelation ? ICON_VALUE_STATE[this.metricThresholdRelation] : ''
    },
    isMetricAggregate(): boolean {
      return this.metric.namespace.key === MetricType.aggregate
    },
    showMetricSuppressButton(): boolean {
      return this.canSuppressMetric && this.metric.isPassing === false && !this.metric.isSuppressed
    }
  }
})
